import React, { useContext, useEffect } from 'react';
import { CartContext } from './components/CartContext';
import { Container, Toast, ToastBody, ToastHeader, CardGroup } from 'reactstrap';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { keyframes } from '@emotion/react';
import logo from './assets/bellyLogo.png';
import fire from './assets/fireBg.png';
import Sauces from './components/Sauces';
import About from './components/About';
import Locations from './components/Locations';
import Contact from './components/Contact';

const theme = createTheme({
  palette: {
    primary: {
      main: '#ff6f61', // warm red-orange
    },
    secondary: {
      main: '#ffc107', // warm yellow
    },
    background: {
      default: '#fef3e2', // soft, warm beige background
    },
    text: {
      primary: '#4e342e', // dark brown text for contrast
      secondary: '#5d4037', // lighter brown
    },
  },
  typography: {
    h2: {
      fontFamily: "'Montserrat', sans-serif",
      fontWeight: 700,
    },
    h5: {
      fontFamily: "'Montserrat', sans-serif",
    },
    body2: {
      fontFamily: "'Roboto', sans-serif",
    },
  },
});

// Keyframes for fade-in animation
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Wrapper styles for fade-in effect
const fadeInStyles = {
  animation: `${fadeIn} 1s ease-out forwards`,
};


const SplashPage = () => {
  const { updateToast, showToast, cartItems } = useContext(CartContext);

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cartItems));

  }, [cartItems]);
  return (
    <ThemeProvider theme={theme}>
        {/* Jumbotron */}
        <div className='jumbo' style={{...fadeInStyles, animationDelay: '0.2s' }}>
          <img
            src={logo}
            alt="Dr. Belly's Logo"
            style={{
              marginBottom: '0.5rem',
            }}
            className='belly-logo'
          />
        </div>
        <div className="belly-container">
          <Sauces />
          <About />
          <Locations />
          <Contact />
      </div>
      { showToast && (
      <div className="p-3 my-2 rounded" style={{ position: 'fixed', top: 20, right: 20, zIndex: 100000 }}>
        <Toast isOpen={updateToast}>
          <ToastBody>
            <h5 className='m-0'>Cart updated!</h5>
          </ToastBody>
        </Toast>
      </div>
      )}
    </ThemeProvider>
  );
};

export default SplashPage;
